import React, {  } from 'react';
import { useParams } from 'react-router-dom';

import { Col, Row, message } from 'antd';
import PageHeader from '../../../components/PageHeader';
import PaymentInfoGeneral from './General';
import PaymentInfo from './Data';
import { useQuery } from "react-query";
import { getPaymentbyId } from "../services";
import Settlement from "./Settlement";

const PaymentInfoPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { isLoading, data } = useQuery({
    queryKey: ['payment-details', id],
    queryFn: () => getPaymentbyId(id),
    enabled: !!id,
    retry: false,
    onError(err) {
      message.error((err as any)?.response?.data?.message)
    },
  })

  if (!data) {
    return (
      <PageHeader
        title="Informações do Pagamento"
        breadcrumb={['Pagamento', 'Informação']}
      />
    )
  }

  return (
    <>
      <PageHeader
        title="Informações do Pagamento"
        breadcrumb={['Pagamento', 'Informação']}
      />
      <PaymentInfoGeneral data={data} loading={isLoading} />
      <Row gutter={16}>
        <Col md={12} xs={24}>
          <PaymentInfo loading={isLoading} data={data} />
        </Col>
        <Col md={12} xs={24}>
          {/* <Payments loading={loading} data={dataBoletoRaw} /> */}
          <Settlement loading={isLoading} data={data} />
        </Col>
      </Row>
    </>
  );
};

export default PaymentInfoPage;
